import { useMutation as useApolloMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

import type { Response, MutationVars } from './mutation'
import createDataRequestMutation from './mutation'

export const useCreateDataRequestMutation: WrappedMutation<Response, MutationVars> = () =>
  useApolloMutation<Response, MutationVars>(createDataRequestMutation, {
    client: agentClient,
    fetchPolicy: 'network-only',
  })
